import type { OnChanges, SimpleChanges } from '@angular/core';
import { Component, Input } from '@angular/core';
import { FontColor, FontWeight, TextSize } from '@freelancer/ui/text';

@Component({
  selector: 'fl-showcase-card-price',
  template: `
    <fl-text
      *ngIf="label"
      [color]="FontColor.LIGHT"
      [weight]="FontWeight.BOLD"
      [size]="currentTextSize"
      [flMarginRight]="'xxsmall'"
    >
      {{ label }}
    </fl-text>
    <div class="CostCircle">
      <fl-text
        i18n="Category Banner Price"
        [color]="FontColor.LIGHT"
        [weight]="FontWeight.BOLD"
        [size]="currentTextSize"
      >
        {{ cost | flCurrency: currency : { withPrecision: false } }}
      </fl-text>
    </div>
  `,
  styleUrls: ['./showcase-card-price.component.scss'],
})
export class ShowcaseCardPriceComponent implements OnChanges {
  FontColor = FontColor;
  FontWeight = FontWeight;
  TextSize = TextSize;

  currentTextSize = TextSize.SMALL;

  @Input() cost: number;
  @Input() currency = 'USD';
  @Input() label?: string;

  ngOnChanges(changes: SimpleChanges): void {
    if ('cost' in changes) {
      const numOfDigits = this.cost.toString().length;
      if (numOfDigits > 5) {
        this.currentTextSize = TextSize.XXXSMALL;
      } else if (numOfDigits > 3) {
        this.currentTextSize = TextSize.XXSMALL;
      } else {
        this.currentTextSize = TextSize.SMALL;
      }
    }
  }
}
